import AvatarEdit from './AvatarEdit';
import container from './AvatarEdit.container';

export default container(AvatarEdit);
